<template>
    <div class="apprentice-simple-card">
        <h4 style="margin-top: 10px">{{ $t('user_account.mail_settings') }}</h4>

        <p>{{ $t('user_account.indicate_below_whether_you_want_to_receive_the_weekly_status_mail') }}</p>
        <p>&nbsp;</p>
        <b-form-checkbox
            class="statusmail"
            v-if="!this.$authUser.isStudent() && userType !== 'organization'"
            v-model="status_mail"
            name="checkbox-1"
            :value="1"
            :unchecked-value="0"
            switch>
            {{ $t('user_account.receive_weekly_status_mail') }}
        </b-form-checkbox>

        <b-form-checkbox
            class="notifications"
            v-model="notifications"
            name="checkbox-1"
            :value="1"
            :unchecked-value="0"
            switch>
            {{ $t('user_account.notifications') }}
        </b-form-checkbox>

        <b-button
            class="btn-save btn-rating-save"
            variant="primary"
            @click="onSubmitStatusMail">
            {{ $t('common.save') }}
        </b-button>
    </div>
</template>

<script>
export default {
    name: 'design-2021-user-account-mail-settings-component',
    props: ['userIn'],
    data() {
        return {
            user: this.userIn,
            status_mail: this.userIn.mail_settings ? this.userIn.mail_settings.status_mail : 1,
            notifications: this.userIn.mail_settings ? this.userIn.mail_settings.notifications : 1,
        };
    },
    methods: {
        onSubmitStatusMail() {
            let data = {
                status_mail: this.status_mail,
                notifications: this.notifications,
            };

            axios.post(this.routes.mailSettings(), data).then(
                (response) => {
                    this.alert.success();
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
    },
};
</script>

<style scoped></style>
